<template>
  <b-form>
    <div class="row mb-3">
      <div class="col-md-6 d-flex align-items-center">
        <span class="fw-bold">Surat Pengantar Laporan Tahunan</span>
        <a
          :href="'https://backend-sea.kkp.go.id/pengendalian/template/FormatLaporanTahunan.pdf'"
          target="_blank"
          class="btn btn-secondary ms-2 text-white"
        >
          <i class="fa fa-eye" />
          Template
        </a>
      </div>
      <div class="col-md-6">
        <div class="row">
          <div>
            <small>Format file: PDF, Ukuran maksimal: 5MB <span class="text-danger">*</span></small>
            <i
              class="fa fa-info-circle ml-1"
              v-b-tooltip.hover.topright="'Silahkan upload Surat Pengantar sebelum mengisi form'"
            />
          </div>
          <div class="col-6">
            <b-form-file
              v-model="form.surat_pengantar"
              id="surat_pengantar"
              plain
              class="form-control"
              name="Surat Pengantar"
              accept=".pdf"
              @change="checkFileSize($event, 'surat_pengantar')"
              :disabled="is_selesai"
            ></b-form-file>
          </div>
          <div class="col-6 d-flex">
            <a
              v-if="!is_selesai"
              :class="['btn btn-primary mr-2 text-white', { disabled: form.surat_pengantar === null }]"
              @click="uploadFile"
            >
              <i class="fa fa-cloud-upload" />
              Unggah
            </a>
            <a
              :class="{
                'btn btn-success': true,
                disabled: id_file_surat_pengantar === null,
              }"
              @click="unduhFile(id_file_surat_pengantar)"
            >
              <i class="fa fa-download" />
              Unduh
            </a>
          </div>
        </div>
        <span class="text-danger" v-if="errors.has('Surat Pengantar')">
          {{ errors.first('Surat Pengantar') }}
        </span>
        <span class="text-danger" v-if="errors.has('surat_pengantar', 'custom')">
          {{ errors.first('surat_pengantar', 'custom') }}
        </span>
      </div>
      <div class="col-md-6 mt-2">
        <label for="nomor_surat_pengantar" class="m-0">Nomor Surat Pengantar <span class="text-danger">*</span></label>
        <b-form-input
          v-model="form.nomor_surat_pengantar"
          id="nomor_surat_pengantar"
          v-validate="'required'"
          name="Nomor Surat Pengantar"
          :class="{ input: true, 'is-danger': errors.has('Nomor Surat Pengantar') }"
          :disabled="is_selesai"
          style="background-color: white"
        ></b-form-input>
        <span class="text-danger" v-if="errors.has('Nomor Surat Pengantar')">
          {{ errors.first('Nomor Surat Pengantar') }}
        </span>
      </div>
      <div class="col-md-6 mt-2">
        <label for="tanggal_surat_pengantar" class="m-0">
          Tanggal Surat Pengantar
          <span class="text-danger">*</span></label
        >
        <b-form-input
          type="date"
          v-model="form.tanggal_surat_pengantar"
          id="tanggal_surat_pengantar"
          v-validate="'required'"
          name="Tanggal Surat Pengantar"
          :class="{ input: true, 'is-danger': errors.has('Tanggal Surat Pengantar') }"
          :disabled="is_selesai"
          style="background-color: white"
        ></b-form-input>
        <span class="text-danger" v-if="errors.has('Tanggal Surat Pengantar')">
          {{ errors.first('Tanggal Surat Pengantar') }}
        </span>
      </div>
    </div>
    <div class="border-bottom mb-3" style="--bs-border-color: black"></div>
    <legend class="text-black fw-bold">Identitas Pemegang Persetujuan/Konfirmasi</legend>
    <div :class="['row mb-5', { 'pe-none opacity-75': !sudah_upload_surat_pengantar }]">
      <div class="col-md-6">
        <label>Jenis Kegiatan <span class="text-danger">*</span></label>
        <v-select
          v-model="form.jenis_kegiatan"
          id="tahun_laporan"
          :reduce="(data) => data.value"
          label="text"
          :options="optionJenisKegiatan"
          name="Jenis Kegiatan"
          v-validate="'required'"
          @input="selectJenisKegiatan"
          :class="{ 'pe-none': is_selesai }"
        />
        <span class="text-danger" v-if="errors.has('Jenis Kegiatan')">
          {{ errors.first('Jenis Kegiatan') }}
        </span>
      </div>
      <div class="col-md-6">
        <label>Nomor KKPRL/Nomor OSS <span class="text-danger">*</span></label>
        <i
          class="fa fa-info-circle ml-1"
          v-b-tooltip.hover.topright="
            'Mohon input secara manual apabila Nomor KKPRL/OSS belum tersedia di dalam sistem'
          "
        />
        <div ref="dropdownNomorKkprl">
          <b-form-input
            v-model="form.no_kkprl"
            id="nomor_kkprl"
            v-validate="'required'"
            name="Nomor KKPRL"
            :class="{ input: true, 'is-danger': errors.has('Nomor KKPRL') }"
            autocomplete="off"
            :placeholder="isJenisKegiatanTerisi ? 'Ketik atau pilih nomor yang tersedia' : 'Pilih jenis kegiatan dahulu'"
            :disabled="is_selesai || !isJenisKegiatanTerisi"
            style="background-color: white"
            @click="toggleOptionKkprl(true)"
          ></b-form-input>
          <div v-if="showOptionKkprl" style="position: relative">
            <div class="option-kkprl-container">
              <div
                v-for="d in filteredNomorKkprl"
                class="option-kkprl-item"
                @click="
                  d.includes('Tidak ada pilihan') || d.includes('Pilih Jenis Kegiatan') ? undefined : selectKkprl(d)
                "
              >
                {{ d }}
              </div>
            </div>
          </div>
        </div>
        <span class="text-danger" v-if="errors.has('Nomor KKPRL')">
          {{ errors.first('Nomor KKPRL') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label>Tahun Laporan <span class="text-danger">*</span></label>
        <i
          class="fa fa-info-circle ml-1"
          v-b-tooltip.hover.topright="'Hanya menampilkan tahun yang belum dilakukan pelaporan tahunan'"
        />
        <v-select
          v-model="form.tahun_laporan"
          id="tahun_laporan"
          :options="filteredTahun"
          name="Tahun Laporan"
          v-validate="'required'"
          @input="checkLaporanIsAvailable"
          :placeholder="!isNomorKkprlTerisi ? 'Isi Nomor KKPRL/Nomor OSS dahulu' : 'Pilih Tahun Laporan'"
          :class="{ 'pe-none': is_selesai }"
        />
        <span class="text-danger" v-if="errors.has('Tahun Laporan')">
          {{ errors.first('Tahun Laporan') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label>Tanggal Penerbitan KKPRL <span class="text-danger">*</span></label>
        <DatePicker
          id="tgl_penerbitan"
          lang="en"
          :placeholder="tgl_penerbitan"
          input-class="form-control"
          @change="
            (val) => {
              this.tgl_penerbitan = val.toLocaleDateString('en-GB')
              this.form.tgl_penerbitan = formatDate(val, 'YYYY-MM-DD')
              this.errors.remove('Tanggal Penerbitan')
            }
          "
          :class="['w-100', { 'pe-none': is_selesai }]"
        >
          <i class="fa fa-calendar-o" slot="calendar-icon" />
        </DatePicker>
        <span class="text-danger" v-if="errors.has('Tanggal Penerbitan')">
          {{ errors.first('Tanggal Penerbitan') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label>Nama Pemegang (Sesuai dengan KKPRL Terbit) <span class="text-danger">*</span></label>
        <b-form-input
          v-model="form.nama_pemegang"
          id="nama_pemegang"
          v-validate="'required'"
          name="Nama Pemegang"
          :class="{
            input: true,
            'is-danger': errors.has('Nama Pemegang'),
          }"
        ></b-form-input>
        <span class="text-danger" v-if="errors.has('Nama Pemegang')">
          {{ errors.first('Nama Pemegang') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label>Nomor Pokok Wajib Pajak <span class="text-danger">*</span></label>
        <b-form-input
          v-model="form.npwp"
          id="npwp"
          v-mask="'##.###.###.#-###.####'"
          v-validate="'required'"
          name="NPWP"
          :class="{ input: true, 'is-danger': errors.has('NPWP') }"
        ></b-form-input>
        <span class="text-danger" v-if="errors.has('NPWP')">
          {{ errors.first('NPWP') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label>Alamat Kantor <span class="text-danger">*</span></label>
        <b-form-textarea
          name="Alamat Kantor"
          v-validate="'required'"
          v-model="form.alamat_kantor"
          id="alamat_kantor"
          rows="3"
          :disabled="is_selesai"
          style="background-color: white"
        ></b-form-textarea>
        <span class="text-danger" v-if="errors.has('Alamat Kantor')">
          {{ errors.first('Alamat Kantor') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label>Nomor Telepon/Faksimil <span class="text-danger">*</span></label>
        <b-form-input
          v-model="form.no_telepon"
          id="no_telepon"
          v-mask="'#############'"
          v-validate="'required'"
          name="No Telepon"
          :class="{
            input: true,
            'is-danger': errors.has('No Telepon'),
          }"
          :disabled="is_selesai"
          style="background-color: white"
        ></b-form-input>
        <span class="text-danger" v-if="errors.has('No Telepon')">
          {{ errors.first('No Telepon') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label>Surat Elektronik <span class="text-danger">*</span></label>
        <b-form-input
          v-model="form.surat_elektronik"
          id="surat_elektronik"
          v-validate="'required|email'"
          name="Surat Elektronik"
          :class="{
            input: true,
            'is-danger': errors.has('Surat Elektronik'),
          }"
          :disabled="is_selesai"
          style="background-color: white"
        ></b-form-input>
        <span class="text-danger" v-if="errors.has('Surat Elektronik')">
          {{ errors.first('Surat Elektronik') }}
        </span>
        <span class="text-danger" v-if="errors.has('email_validation') && !errors.has('Surat Elektronik')">
          {{ errors.first('email_validation') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label>Status Penanaman Modal <span class="text-danger">*</span></label>
        <v-select
          v-model="form.status_penanaman_modal"
          id="status_penanaman_modal"
          :reduce="(data) => data.value"
          label="text"
          :options="optionStatusPenanamanModal"
          name="Status Penanaman"
          v-validate="'required'"
          :class="{ 'pe-none': is_selesai }"
        />
        <b-form-input
          v-if="form.status_penanaman_modal === 'Lainnya'"
          v-model="form.status_penanaman_modal_lainnya"
          id="status_penanaman_modal_lainya"
          v-validate="'required'"
          name="Status Penanaman"
        ></b-form-input>
        <span class="text-danger" v-if="errors.has('Status Penanaman')">
          {{ errors.first('Status Penanaman') }}
        </span>
      </div>
    </div>

    <legend class="text-black fw-bold">Identitas Penanggung Jawab</legend>
    <div :class="['row', { 'pe-none opacity-75': !sudah_upload_surat_pengantar }, { 'pe-none': is_selesai }]">
      <div class="col-md-6">
        <label>Nama Penanggung Jawab <span class="text-danger">*</span></label>
        <b-form-input
          v-model="form.nama_penanggung_jawab"
          id="nama_penanggung_jawab"
          v-validate="'required'"
          name="Nama Penanggung Jawab"
          :class="{
            input: true,
            'is-danger': errors.has('Nama Penanggung Jawab'),
          }"
        ></b-form-input>
        <span class="text-danger" v-if="errors.has('Nama Penanggung Jawab')">
          {{ errors.first('Nama Penanggung Jawab') }}
        </span>
      </div>
      <div class="col-md-6">
        <label>Jabatan Penanggung Jawab <span class="text-danger">*</span></label>
        <b-form-input
          v-model="form.jabatan_penanggung_jawab"
          id="jabatan_penanggung_jawab"
          v-validate="'required'"
          name="Jabatan Penanggung Jawab"
          :class="{
            input: true,
            'is-danger': errors.has('Jabatan Penanggung Jawab'),
          }"
        ></b-form-input>
        <span class="text-danger" v-if="errors.has('Jabatan Penanggung Jawab')">
          {{ errors.first('Jabatan Penanggung Jawab') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label>Nomor Telepon Seluler <span class="text-danger">*</span></label>
        <b-form-input
          v-model="form.no_telepon_penanggung_jawab"
          id="no_telepon_penanggung_jawab"
          v-mask="'#############'"
          v-validate="'required'"
          name="No Telepon Penanggung Jawab"
          :class="{
            input: true,
            'is-danger': errors.has('No Telepon Penanggung Jawab'),
          }"
        ></b-form-input>
        <span class="text-danger" v-if="errors.has('No Telepon Penanggung Jawab')">
          {{ errors.first('No Telepon Penanggung Jawab') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label>Surat Elektronik <span class="text-danger">*</span></label>
        <b-form-input
          v-model="form.surel_penanggung_jawab"
          id="surel_penanggung_jawab"
          v-validate="'required|email'"
          name="Surat Elektronik Penanggung Jawab"
          :class="{
            input: true,
            'is-danger': errors.has('Surat Elektronik Penanggung Jawab'),
          }"
        ></b-form-input>
        <span class="text-danger" v-if="errors.has('Surat Elektronik Penanggung Jawab')">
          {{ errors.first('Surat Elektronik Penanggung Jawab') }}
        </span>
        <span
          class="text-danger"
          v-if="errors.has('email_validation2') && !errors.has('Surat Elektronik Penanggung Jawab')"
        >
          {{ errors.first('email_validation2') }}
        </span>
      </div>
    </div>

    <div class="mt-5 fw-bold">Note: tanda (<span class="text-danger">*</span>) wajib diisi</div>
  </b-form>
</template>

<script>
import vSelect from 'vue-select'
import DatePicker from 'vue2-datepicker'
import { formatDate } from '../../helper/helpernew'
import axios from 'axios'
import Swal from 'sweetalert2'
import { telpMask } from '../../helper/validationHelper'

export default {
  components: {
    vSelect,
    DatePicker,
  },
  data() {
    return {
      baseapiPengendalian: localStorage.getItem('baseapiPengendalian'),
      user: JSON.parse(localStorage.getItem('userPengendalian')),
      no_oss: null,
      form: {
        surat_pengantar: null,
        nomor_surat_pengantar: '',
        tanggal_surat_pengantar: '',
        no_kkprl: '',
        jenis_kegiatan: '',
        tahun_laporan: '',
        tgl_penerbitan: null,
        nama_pemegang: '',
        npwp: '',
        alamat_kantor: '',
        no_telepon: '',
        surat_elektronik: '',
        status_penanaman_modal: '',
        status_penanaman_modal_lainnya: '',
        nama_penanggung_jawab: '',
        jabatan_penanggung_jawab: '',
        no_telepon_penanggung_jawab: '',
        surel_penanggung_jawab: '',
      },
      showOptionKkprl: false,
      dataPerizinan: [],
      dataNomorKkprl: [],
      listLaporanExist: [],
      dataLaporan: null,
      is_selesai: false,
      sudah_upload_surat_pengantar: false,
      id_file_surat_pengantar: null,
      tgl_penerbitan: 'dd/mm/yyyy',
      optionTahunLaporan: [],
      // prettier-ignore
      optionStatusPenanamanModal: [
        { value: 'Penanaman Modal Dalam Negeri (PMDN)', text: 'Penanaman Modal Dalam Negeri (PMDN)', },
        { value: 'Penanaman Modal Asing (PMA)', text: 'Penanaman Modal Asing (PMA)', },
        { value: 'Lainnya', text: 'Lainnya', },
        { value: 'Tidak Ada', text: 'Tidak Ada', },
      ],
      // prettier-ignore
      optionJenisKegiatan: [
        { value: 'Berusaha', text: 'Berusaha', },
        { value: 'Non Berusaha', text: 'Non Berusaha', },
      ],
    }
  },
  inject: ['inj_is_selesai', 'setIsSelesai', 'inj_data_laporan', 'setDataLaporan'],
  async mounted() {
    document.addEventListener('click', this.handleClickOutside)
    this.loadDataUser()
    await this.loadLaporanTahunan()
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    telpMask,
    formatDate,

    handleClickOutside(e) {
      const dropdown = this.$refs.dropdownNomorKkprl
      if (!dropdown) return
      if (!dropdown.contains(e.target)) {
        this.toggleOptionKkprl(false)
      }
    },

    loadDataUser() {
      this.form.nama_pemegang = this.user.nama
      this.form.npwp = this.user.npwp
      this.form.surat_elektronik = this.user.email
    },

    uploadFile() {
      this.$loading(true)
      const formData = new FormData()
      formData.append('file_surat_pengantar', this.form.surat_pengantar)

      if (!this.$route.query.id_laporan) {
        axios
          .post(this.baseapiPengendalian + 'api/laporan_tahunan', formData, this.getApiOption())
          .then(async (res) => {
            this.$toasted.success('Berhasil Diunggah')
            this.$router.replace({
              path: this.$route.path,
              query: { id_laporan: res.data.data.id },
            })
            this.loadLaporanTahunan()
            this.sudah_upload_surat_pengantar = true
            this.id_file_surat_pengantar = res.data.data.id_file_surat_pengantar
            this.form.surat_pengantar = null
          })
          .catch((err) => {
            this.$toasted.danger('Gagal Diunggah')
          })
          .finally(() => {
            this.$loading(false)
          })
      } else {
        axios
          .post(this.baseapiPengendalian + 'api/laporan_tahunan/' + this.$route.query.id_laporan, formData, this.getApiOption())
          .then(async (res) => {
            this.$toasted.success('Berhasil Diunggah')
            this.id_file_surat_pengantar = res.data.data.id_file_surat_pengantar
            this.form.surat_pengantar = null
          })
          .catch((err) => {
            this.$toasted.danger('Gagal Diunggah')
          })
          .finally(() => {
            this.$loading(false)
          })
      }
    },

    async nextForm() {
      if (this.is_selesai) {
        return true
      }

      if (this.form.tgl_penerbitan === null) {
        this.errors.add({
          field: 'Tanggal Penerbitan',
          msg: 'Tanggal Penerbitan wajib diisi',
        })
      }

      if ((await this.$validator.validateAll()) && !this.errors.any()) {
        this.$loading(true)
        const formData = new FormData()
        // prettier-ignore
        {
          formData.append('nomor_surat_pengantar', this.form.nomor_surat_pengantar)
          formData.append('tanggal_surat_pengantar', this.form.tanggal_surat_pengantar)
          formData.append('nomor_kkprl', this.form.no_kkprl.replaceAll(" ", ''))
          formData.append('tahun_laporan', this.form.tahun_laporan)
          formData.append('jenis_kegiatan', this.form.jenis_kegiatan)
          formData.append('nama_pemegang', this.form.nama_pemegang)
          formData.append('alamat_kantor', this.form.alamat_kantor)
          formData.append('email', this.form.surat_elektronik)
          formData.append('tanggal_penerbitan', this.form.tgl_penerbitan)
          formData.append('npwp', this.form.npwp)
          formData.append('no_telepon', this.form.no_telepon)
          if (this.form.status_penanaman_modal !== 'Lainnya') {
            formData.append('status_penanaman_modal', this.form.status_penanaman_modal)
          } else {
            formData.append('status_penanaman_modal', this.form.status_penanaman_modal_lainnya)
          }
          formData.append('nama_penanggungjawab', this.form.nama_penanggung_jawab)
          formData.append('jabatan_penanggungjawab', this.form.jabatan_penanggung_jawab)
          formData.append('no_hp_penanggungjawab', this.form.no_telepon_penanggung_jawab)
          formData.append('email_penanggungjawab', this.form.surel_penanggung_jawab)
        }

        return axios
          .post(this.baseapiPengendalian + `api/laporan_tahunan/${this.$route.query.id_laporan}`, formData, this.getApiOption())
          .then(async (res) => {
            this.$loading(false)
            await Swal.fire('Berhasil', 'Identitas Laporan Tahunan tersimpan', 'success')
            return true
          })
          .catch((err) => {
            this.$loading(false)
            Swal.fire('Gagal', 'Terjadi kesalahan', 'error')
            return false
          })
      } else {
        return false
      }
    },

    async loadLaporanTahunan() {
      if (!this.$route.query.id_laporan) {
        return
      }

      this.$loading(true)
      try {
        const url =
          this.user.role === 'Pemrakarsa'
            ? `${this.baseapiPengendalian}api/laporan_tahunan?filter=id_user,=,${this.user.id}&limit=0`
            : `${this.baseapiPengendalian}api/laporan_tahunan/${this.$route.query.id_laporan}`
        const res = await axios.get(url, this.getApiOption())
        const resData = this.user.role === 'Pemrakarsa' ? res.data.data : [res.data.data]
        this.listLaporanExist = resData
        const data = resData.find((d) => d.id == this.$route.query.id_laporan)
        if (data) {
          this.sudah_upload_surat_pengantar = true
          this.dataLaporan = data
          this.setDataLaporan(data)
          this.is_selesai =
            data.status_laporan !== null &&
            data.status_laporan !== 'Draft' &&
            data.status_laporan !== 'Komentar/Informasi terhadap Penyampaian Laporan Tahunan'
          if (this.is_selesai) this.setIsSelesai(this.is_selesai)
          Object.assign(this.form, {
            nomor_surat_pengantar: data.nomor_surat_pengantar || '',
            tanggal_surat_pengantar: data.tanggal_surat_pengantar || '',
            no_kkprl: data.nomor_kkprl || '',
            tahun_laporan: data.tahun_laporan || '',
            jenis_kegiatan: data.jenis_kegiatan || '',
            tgl_penerbitan: data.tanggal_penerbitan,
            nama_pemegang: data.nama_pemegang || this.user.nama || '',
            npwp: data.npwp || this.user.npwp || '',
            alamat_kantor: data.alamat_kantor || '',
            no_telepon: data.no_telepon || '',
            surat_elektronik: data.email || this.user.email || '',
            nama_penanggung_jawab: data.nama_penanggungjawab || '',
            jabatan_penanggung_jawab: data.jabatan_penanggungjawab || '',
            no_telepon_penanggung_jawab: data.no_hp_penanggungjawab || '',
            surel_penanggung_jawab: data.email_penanggungjawab || '',
          })
          // prettier-ignore
          if (data.status_penanaman_modal && !this.optionStatusPenanamanModal.find((d) => d.value === data.status_penanaman_modal)) {
            this.form.status_penanaman_modal = 'Lainnya'
            this.form.status_penanaman_modal_lainnya = data.status_penanaman_modal
          } else if (data.status_penanaman_modal) {
            this.form.status_penanaman_modal = data.status_penanaman_modal
          }
          this.id_file_surat_pengantar = data.id_file_surat_pengantar
          if (data.tanggal_penerbitan) {
            this.tgl_penerbitan = formatDate(data.tanggal_penerbitan, 'DD/MM/YYYY')
          }
          if (data.jenis_kegiatan) {
            this.getPermohonan()
          }
        }
        // this.getTahunLaporan()
      } catch (error) {
        Swal.fire('Gagal', 'Terjadi kesalahan saat mengambil data', 'error')
      } finally {
        this.$loading(false)
      }
    },

    async checkLaporanIsAvailable() {
      if (this.dataLaporan?.tahun_laporan === this.form.tahun_laporan) return
      const res = await axios.get(
        `${this.baseapiPengendalian}api/laporan_tahunan?filter=id_user,=,${this.user.id};nomor_kkprl,=,${this.form.no_kkprl};tahun_laporan,=,${this.form.tahun_laporan};jenis_kegiatan,=,${this.form.jenis_kegiatan}`,
        this.getApiOption(),
      )
      if (res.data?.data?.length) {
        Swal.fire(`Laporan tahunan tahun ${this.form.tahun_laporan} sudah dilaporkan`, '', 'info').then((res) => {
          this.form.tahun_laporan = ''
        })
      }
    },

    selectJenisKegiatan() {
      this.form.no_kkprl = ''
      this.form.nama_pemegang = this.user.nama
      this.form.tgl_penerbitan = ''
      this.form.npwp = this.user.npwp
      this.form.surat_elektronik = ''
      this.form.alamat_kantor = ''
      this.form.no_telepon = ''
      this.tgl_penerbitan = ''
      this.getPermohonan()
    },

    async getPermohonan() {
      this.$loading(true)
      if (this.form.jenis_kegiatan === 'Berusaha') {
        await axios
          .get(
            this.baseapiPengendalian +
              `api/ref/getPermohonan/Berusaha?filter=npwp_pemohon,=,${this.user.npwp};keterangan_status,=,Terbit`,
            this.getApiOption(),
          )
          .then((res) => {
            const data = res.data.data
            this.dataPerizinan = data
            this.dataNomorKkprl = data.length ? data.map((d) => d.nomor_oss) : ['Tidak ada pilihan Nomor KKPRL/OSS']
          })
      } else {
        await axios
          .get(
            this.baseapiPengendalian +
              `api/ref/getPermohonan/Nonberusaha?filter=npwp_pemohon,=,${this.user.npwp};keterangan_status,=,Terbit`,
            this.getApiOption(),
          )
          .then((res) => {
            const data = res.data.data
            this.dataPerizinan = data
            this.dataNomorKkprl = data.length ? data.map((d) => d.nomor_kkp) : ['Tidak ada pilihan Nomor KKPRL/OSS']
          })
      }
      this.$loading(false)
    },

    selectKkprl(d) {
      this.form.no_kkprl = d

      if (this.form.jenis_kegiatan === 'Berusaha') {
        const data = this.dataPerizinan.find((dd) => dd.nomor_oss === d)
        if (data) {
          this.form.nama_pemegang = data.nama_pemohon
          this.form.tgl_penerbitan = data.tanggal_terbit_oss
          this.form.npwp = data.npwp_pemohon
          this.form.surat_elektronik = data.email_pemohon
          // this.form.alamat_kantor = ''
          // this.form.no_telepon = ''
          this.tgl_penerbitan = data.tanggal_terbit_oss
            ? formatDate(data.tanggal_terbit_oss, 'DD/MM/YYYY')
            : 'dd/mm/yyyy'
        }
      } else {
        const data = this.dataPerizinan.find((dd) => dd.nomor_kkp === d)
        if (data) {
          this.form.nama_pemegang = data.instansi_pemohon
          this.form.tgl_penerbitan = data.tanggal_ttd_mkp
          this.form.npwp = data.npwp_pemohon
          this.form.surat_elektronik = data.email_pemohon
          this.form.alamat_kantor = data.alamat_pemohon
          this.form.no_telepon = data.no_hp_pemohon
          this.tgl_penerbitan = data.tanggal_ttd_mkp ? formatDate(data.tanggal_ttd_mkp, 'DD/MM/YYYY') : 'dd/mm/yyyy'
        }
      }

      this.toggleOptionKkprl(false)
    },

    toggleOptionKkprl(val) {
      this.showOptionKkprl = val
    },

    inputNoKkprl() {
      this.form.jenis_kegiatan = ''
    },

    checkFileSize(e, field) {
      const file = e.target.files[0]
      const maxSize = 5 * 1024 * 1024

      if (file && file.size > maxSize) {
        this.errors.add({
          field: field,
          msg: 'Ukuran file maksimal 5MB',
          scope: 'custom',
        })
        e.target.value = null
        this.form[field] = null
      } else {
        this.errors.remove(field, 'custom')
      }
    },

    async getTahunLaporan() {
      const existingYear = new Set()
      for (const d of this.listLaporanExist) {
        if (d.tahun_laporan) existingYear.add(parseInt(d.tahun_laporan))
      }
      if (this.dataLaporan?.tahun_laporan) {
        existingYear.delete(parseInt(this.dataLaporan.tahun_laporan))
      }
      const date = new Date()
      const year = date.getFullYear() + 1
      const option = []
      for (let i = year; i > year - 10 - existingYear.size; i--) {
        if (!existingYear.has(i)) {
          option.push(`${i}`)
        }
      }
      this.optionTahunLaporan = option
    },

    async unduhFile(id) {
      const res = await axios.get(
        `${this.baseapiPengendalian}api/files/download/${id}`,
        this.getApiOption({ responseType: 'blob' }),
      )
      const file = new Blob([res.data], { type: res.data.type })
      const fileURL = URL.createObjectURL(file)
      window.open(fileURL, '_blank')
    },

    getApiOption(option = {}) {
      return {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken,
        },
        ...option,
      }
    },
  },
  computed: {
    isNomorKkprlTerisi() {
      return Boolean((this.form.no_kkprl || '').trim())
    },
    isJenisKegiatanTerisi() {
      return Boolean((this.form.jenis_kegiatan || '').trim())
    },
    filteredNomorKkprl() {
      const filtered = this.dataNomorKkprl.filter((d) => d.includes(this.form.no_kkprl))
      if (!this.form.jenis_kegiatan) {
        return ['Pilih Jenis Kegiatan terlebih dahulu']
      }
      return filtered.length ? filtered : ['Tidak ada pilihan Nomor KKPRL/OSS']
    },
    filteredTahun() {
      if (!this.isNomorKkprlTerisi) {
        return []
      }

      const existingYear = new Set()
      const filteredLaporan =
        this.form.jenis_kegiatan && this.form.no_kkprl
          ? this.listLaporanExist.filter(
              (d) => d.jenis_kegiatan === this.form.jenis_kegiatan && d.nomor_kkprl === this.form.no_kkprl,
            )
          : []
      for (const d of filteredLaporan) {
        if (d.tahun_laporan) existingYear.add(parseInt(d.tahun_laporan))
      }
      if (this.dataLaporan?.tahun_laporan) {
        existingYear.delete(parseInt(this.dataLaporan.tahun_laporan))
      }
      const date = new Date()
      const year = date.getFullYear() + 1
      const option = []
      for (let i = year; i > year - 10 - existingYear.size; i--) {
        if (!existingYear.has(i)) {
          option.push(`${i}`)
        }
      }
      return option
    },
  },
  watch: {
    isNomorKkprlTerisi(isTerisi) {
      if (!isTerisi) {
        this.form.tahun_laporan = ''
      }
    },
  },
}
</script>

<style scope>
.option-kkprl-container {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  background: white;
  z-index: 10;
  border-radius: 5px;
  border: 1px solid #aaaaaa;
  overflow-y: auto;
  scrollbar-width: thin;
  max-height: 200px;
}

.option-kkprl-item {
  cursor: pointer;
  padding: 5px 10px;
}

.option-kkprl-item:hover {
  background: #dddddd;
}
</style>
